import React, { useMemo } from 'react'
import * as classes from './ThirdScreen.module.scss'
import cn from 'classnames'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { Button } from '../../../ui/Button/Button'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { useDataThirdScreenByEn } from './useDataThirdScreenByEn'
import { useDataThirdScreenByHy } from './useDataThirdScreenByHy'
import { navigate } from 'gatsby'
import { useDataSecondScreenByHy } from '../SecondScreen/useDataSecondScreenByHy'
import { useDataSecondScreenByEn } from '../SecondScreen/useDataSecondScreenByEn'

function ThirdScreen({ lang }) {
    const dataThirdScreenByEn = useDataThirdScreenByEn()
    const dataThirdScreenByHy = useDataThirdScreenByHy()
    const dataSecondScreenByHy = useDataSecondScreenByHy()
    const dataSecondScreenByEn = useDataSecondScreenByEn()

    const dataThirdScreen = lang === 'hy' ? dataThirdScreenByHy : dataThirdScreenByEn
    const dataSecondScreen = lang === 'hy' ? dataSecondScreenByHy : dataSecondScreenByEn

    const sectionTitle = useMemo(() => deleteHtmlTag(dataThirdScreen.sectionTitle.value, 'p'), [])
    const title = useMemo(() => deleteHtmlTag(dataThirdScreen.title.value, 'p'), [])
    const text = useMemo(() => deleteHtmlTag(dataThirdScreen.text.value, 'p'), [])
    const buttonText = useMemo(() => deleteHtmlTag(dataThirdScreen.buttonText.value, 'p'), [])
    const aboutText = useMemo(() => deleteHtmlTag(dataSecondScreen.title.value, 'p'), [])

    const buttonUrl = lang === 'hy' ? `/company/about/` : `/en/company/about/`

    return (
        <div className={cn(classes.Inner, { [classes.LangHY]: lang === 'hy' })}>
            <div className={`${classes.AllContent} main-slider-content`}>
                <div className={classes.WhiteBlock}>
                    <SectionTitle className={classes.SectionTitle} title={sectionTitle} lang={lang} />

                    <div className={classes.Diagonal} />

                    <div className={classes.Content}>
                        <h2 className={classes.Title} dangerouslySetInnerHTML={{ __html: title }} />
                        <p className={classes.Text} dangerouslySetInnerHTML={{ __html: `${text}` }} />

                        <Button className={classes.Btn} onClick={() => navigate(buttonUrl)}>
                            {buttonText}
                        </Button>
                    </div>
                </div>
                <div className={classes.TextContent}>
                    <h2 className={`${classes.Title} ${classes.AboutText}`} dangerouslySetInnerHTML={{ __html: aboutText }} />
                </div>
            </div>
        </div>
    )
}

export default ThirdScreen
